import { useNavigation } from '@react-navigation/native';
import { images } from '_/space-management/assets';
import { Avatar, Text } from '_/space-management/components';
import { useAuth } from '_/space-management/hooks/AuthContext';
import { useOrganizationContext } from '_/space-management/hooks/OrganizationContext';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Image,
  View,
  ScrollView,
  RefreshControl,
} from 'react-native';

import styles from './styles';
import { fontSizes } from '_/config/theme';

export default function OrganizationDisabled() {
  const { member, updateMember } = useAuth();
  const { getOrganization, getMember } = useOrganizationContext();
  const { t } = useTranslation();

  return (
    <ScrollView
      refreshControl={
        <RefreshControl
          refreshing={false}
          onRefresh={async () => {
            if (member) {
              await getOrganization(member?.organizationId);
              const [reloadMember] = await getMember(member.userId, member.organizationId);
              if (reloadMember) await updateMember(reloadMember);
            }
          }}
        />
      }
    >
      <View style={{ flex: 1 }}>
          <Text style={[styles.text, { fontWeight: '600' }]} fontSize={fontSizes.md2}>
            {t('spaceManage.onBoarding.organizationDisabled', { organizationName: 'organizationData.name' })}
          </Text>
          <View style={styles.imageOrganizationDisabled}>
            <Image resizeMode="contain" source={images.notFound} style={styles.img} />
          </View>
          <Text style={styles.text} fontSize={fontSizes.md2}>
            {t('spaceManage.onBoarding.moreInfo')}
          </Text>
        </View>
    </ScrollView>
  );
}
